import classNames from 'classnames';
import { FC, MouseEvent, ReactElement, RefObject } from 'react';

import MaterialIcon, { IconNames } from '../MaterialIcon/MaterialIcon';
import styles from './Button.module.scss';

export interface ButtonProps {
  ariaLabel?: string;
  buttonRef?: RefObject<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
  icon?: { direction?: 'left' | 'right'; name: IconNames };
  img?: ReactElement;
  isLoading?: boolean;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  size?: 'default' | 'full' | 'small';
  text?: string;
  type?: 'button' | 'reset' | 'submit';
  variant?: 'contained' | 'outline' | 'text';
}

const Button: FC<ButtonProps> = ({
  buttonRef, img, icon, text, disabled, type = 'button', className, onClick, ariaLabel, variant = 'contained',
  size = 'default', isLoading = false,
}) => {
  const buttonClassNames = classNames(styles.btn, className, {
    [styles.btnText]: variant === 'text',
    [styles.btnContained]: variant === 'contained',
    [styles.btnOutline]: variant === 'outline',
    [styles.btnDisabled]: disabled,
    [styles.btnLoading]: isLoading,
    [styles.btnSmall]: size === 'small',
    [styles.btnFull]: size === 'full',
    [styles.btnWithText]: text,
    [styles.btnIconOnly]: !text && (icon),
    [styles.reverseItems]: icon?.direction === 'right',
  });

  const iconClassNames = classNames({
    [styles.disabledColor]: disabled,
  });

  return (
    <button
      aria-label={ariaLabel}
      className={buttonClassNames}
      disabled={disabled}
      onClick={(event) => !disabled && onClick && !isLoading ? onClick(event) : undefined}
      ref={buttonRef}
      type={type}
    >
      {icon && !isLoading && <MaterialIcon className={iconClassNames} name={icon.name} />}
      {isLoading && <div className={styles.loader} />}
      {img}
      {text && <span className={styles.btnTextSpan}>{text}</span>}
    </button>
  );
};

export default Button;
